module.exports = __webpack_public_path__ + "img/screen-users.838f8b11.svg";